import { render, staticRenderFns } from "./fotos_classificadas.vue?vue&type=template&id=6f49a223&scoped=true"
import script from "./fotos_classificadas.vue?vue&type=script&lang=js"
export * from "./fotos_classificadas.vue?vue&type=script&lang=js"
import style0 from "./fotos_classificadas.vue?vue&type=style&index=0&id=6f49a223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f49a223",
  null
  
)

export default component.exports